export default __webpack_public_path__ + "static/media/ic-help-desk.cce6cae2.svg";